<template>
  <Head title="Password zurücksetzen"/>
  <div class="min-h-screen bg-gray-50 flex justify-center items-center">
    <div class="flex-row justify-center items-center">
      <div class="login-card  p-6">
        <div class="w-full max-w-md">
          <logo class="block mx-auto w-full login-card__brand fill-white" height="50"/>
          <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
            <div class="px-10 py-12">
              <h1 class="text-center text-xl md:text-3xl font-bold">Password zurücksetzen</h1>

              <div class="mt-6 mx-auto w-24 border-b-2"/>

              <alert v-if="msg" type="danger">{{ msg }}</alert>
              <alert v-if="$page.props.success" type="success" >{{ $page.props.success }}</alert>
              <text-input v-model="form.email" :error="form.errors.email" class="mt-10" :label="__('general.email')"
                          type="email" autofocus autocapitalize="off"
              />
            </div>
            <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
              <loading-button :loading="form.processing" class="btn-primary ml-auto" type="submit">
                E-Mail anfordern
              </loading-button>
            </div>
          </form>
        </div>
      </div>
      <div class="flex justify-center text-sm gap-4">
        <dgvt-legal/>
      </div>
    </div>
  </div>

</template>

<script>

import {Head} from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import DgvtLegal from '../../Shared/Navigation/DgvtLegal'

export default {

  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
    DgvtLegal
  },

  props: {
    config: Object,
    email: {
      type: String,
      required: false,
    },
    msg: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      form: this.$inertia.form({
        email: this.email,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/passwort-vergessen')
    },
  },
}
</script>
